import { MatxLoading } from 'app/components/template/partials';
import { Suspense } from 'react';

export default function MatxSuspense({ children }){
  return <Suspense fallback={<MatxLoading />}>{children}</Suspense>;
};
